export class ContactsVm {
        DatabaseID: number;
        OrganizationID: number;
        UserID: string;
}


export class CompanysVm {
        DatabaseID: number;
        OrganizationID: number;
        UserID: string;
        CoreID:number;
        ContactID:number;
        CompanyID:number;
        CompanyCoreUserMapID:number;
        ContactCompanyRoleID:number
        ContactCompanyUserMapID:number;
        //CoreCompanyRoleID:number;
        companyCoreRoleID:number;
        contactCompanyRoleID:number;
        AddUpdateCoreCompanyListModel:any=[];
        AddUpdateCoreContactCompanyListModel:any=[];
        CoreCompanyRoleModels: any;
        CoreContactCompanyRoleModels: any;
        IsAdded:boolean;
        OfficeID:any;
}

// export class ContactCompanysVm {
//         DatabaseID: number;
//         OrganizationID: number;
//         UserID: string;
//         CoreID:number;
//         ContactID:number;
//         CompanyID:number;
//         CompanyCoreUserMapID:number;
//         //CoreCompanyRoleID:number;
//         companyCoreRoleID:number;
//         AddUpdateCoreCompanyListModel:any=[];
//         CoreCompanyRoleModels: any;
//         IsAdded:boolean;
// }

export class CompanyVm {
        DatabaseID: number;
        OrganizationID: number;
        UserID: string;
        PageIndex:number;
        PageSize:number;
        FolderId:number;
        transactionID:string;
        subFolderID:number;
        officeID:number;
        searchKey:string;
        companyID:number;
        userContactID: number;
        roleIDList:any=[];
        OfficeIDList: any;
        isArchived:boolean=false; 
        isKanbanView:boolean=false;
}

export class AddCompanyVm {
        UserID: string;
        DatabaseID: number;
        OrganizationID: number;
        TransactionID:string;
        CompanyID:number;
        Fields:Fields[];  
        FolderID:number;    
        ImageUrl:string; 
        TypeID:number;
        Tags: string;
        officeID:number=0;
        OfficeIDList: any;
        Status:string="";
}

export class ReorderColumnCompanyVm {
        UserID: string;
        FieldID:number;
        PreviousPosition:number;
        CurrentPosition:number;
        FolderID:number;
        OrganizationID: number;
        DatabaseID: number;     
  
}


export class UpdateColumnCompanyVm {
        UserID: string;
        DatabaseID: number;
        OrganizationID: number;       
        CustomizationGridUserSetting:CustomizationGridUserSetting[];     
        officeID:number=0;
        OfficeIDList:[];    
}
export class Fields{
        FieldID:number;
        FieldName:string;
        FieldValue:string;           
    }

    export class CustomizationGridUserSetting{
        FieldID:number;
        FolderID:number;
        IsDisplay:boolean;    
        ViewOrder:number;       
    }

    export class FileCompanyModelVM{
        UserID: string;
        DatabaseID: number;
        OrganizationID: number;
        Base64String:string; 
        FileName:string; 
        FileExtention:string;   
    }


    export class CreateCompanyFilterVm {
        userID: string;
        organizationID: number;
        databaseID: number;
        filterName:string;
        folderID:number;
        isDefault:boolean;
        isFavourite:boolean; 
        officeID:number;  
        filterFieldsRequestModels:filterFieldsRequestModels[];
}

export class filterFieldsRequestModels{
        filterValue:string;
        childFieldType:number;
        fieldID:any;    
        fieldTypeID:number;  
        organizationID:number;     
    }

    export class FilteredCompanyVm {
        PageIndex:number;
        PageSize:number;
        UserID: string;
        FolderId:number;
        DatabaseID: number;
        OrganizationID: number;
        fields:fields[];
        searchValue:string;
        CoreID: number;
        ContactID:number;
      userContactID: number;
      roleIDList:any=[];
      officeIDList: any=[];
      officeID:number=0;
}

export class fields{
        filterFieldID:number;
        filterFieldValue:string;
        childFieldType:any;     
    }